import { atom } from 'jotai'

import { GetScoredCategoriesResponse } from '@appTypes/PagesApi.interface'

export const scoredDataAtom = atom({} as GetScoredCategoriesResponse)
